import { render, staticRenderFns } from "./salesForecastAnalysis.vue?vue&type=template&id=1c023a2c&scoped=true"
import script from "./salesForecastAnalysis.vue?vue&type=script&lang=js"
export * from "./salesForecastAnalysis.vue?vue&type=script&lang=js"
import style0 from "./salesForecastAnalysis.vue?vue&type=style&index=0&id=1c023a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c023a2c",
  null
  
)

export default component.exports